import axios from "axios";

const BASE_ENDPOINT = process.env.contact_from_api

class RegisterBlogFormService {
    id: string | undefined
    constructor() {
        this.id = process.env.id_submit_blog_form
    }
    submit(formData:any) {
        const url = `${BASE_ENDPOINT}/${this.id}`
        return axios.post(url,  formData)
    }
}



export class RegisterBlogRequest {
    firstname: string = ''
    lastname: string = ''
    email: string = ''
    constructor(data:any = {}) {
        this.firstname = data.firstname || ''
        this.lastname = data.lastname || ''
        this.email = data.email || ''
        // this.description_note = data.description_note || DEFAULT_DESCRIPTION
    }
}

export default new RegisterBlogFormService()